export const getMeta = (tag: string) =>
  (typeof document === "undefined" ? undefined : document)?.head
    ?.querySelector(`meta[name='${tag}']`)
    ?.getAttribute("content") ?? "missing";

export const getCsrfToken = () => getMeta("csrf-token");
